import { Box, Flex, Typography, theme } from '@fe-toolkit/web-components/ssr'
import Image from 'next/image'

import { Gear } from './icons/Gear'
import { FixedIconLink } from './MemberGreeting.styled'

import type { MemberGreetingData } from './MemberGreeting.types'

function formatMsisdn(msisdn: string | undefined): string | undefined {
  if (!msisdn) return undefined

  if (msisdn.startsWith('+44')) return '0' + msisdn.slice(3)

  if (msisdn.startsWith('44')) return '0' + msisdn.slice(2)

  return msisdn
}

export function MemberGreeting({ memberData }: { memberData: MemberGreetingData | undefined }) {
  const { memberName, msisdn, hasActiveSim } = memberData ?? {}
  const giffgaffPhoneNumber = hasActiveSim ? formatMsisdn(msisdn) : undefined

  return (
    <Flex
      alignItems="center"
      columnGap={theme.spacing.small}
      marginBottom={theme.spacing.large}
      sx={{ display: 'inline-flex' }}
    >
      <Image
        alt="profile icon"
        height={72}
        src="https://www.giffgaff.com/styleguide/svg/gamification/avatar_default.svg"
        width={72}
      />
      <Box
        alignItems="center"
        columnGap={theme.spacing.small}
        flexWrap="wrap"
        rowGap={theme.spacing.tiny}
        sx={({ theme }) => ({
          position: 'relative',
          paddingRight: '34px',
          [theme.breakpoints.up('medium')]: {
            display: 'inline-flex',
          },
        })}
      >
        <Typography
          as="p"
          sx={{ whiteSpace: 'break-spaces', wordBreak: 'break-word' }}
          testId="member-greeting-text"
          variant="louder"
        >
          Hi {memberName}
        </Typography>
        {giffgaffPhoneNumber && (
          <Typography as="p" variant="speak">
            {giffgaffPhoneNumber}
          </Typography>
        )}
        <FixedIconLink href="/profile/details">
          <Gear title="Edit profile and settings" />
        </FixedIconLink>
      </Box>
    </Flex>
  )
}
